<template> 
    <div>
        <component
            v-for="(field, key) in schema"
            :key="key"
            :name="key"
            :is="field.component"
            v-bind="{...field}"
            :value="value[key]"
            @input="update(key, $event)"
            :hasError="$v.form[key].$error"
            :error="errorMessages[key]"
        >
        </component>
        <!-- <button :click="validate()">Validar</button> -->
    </div>
</template>

<script>
import { validationRules } from '@/parsers/ValidationParser'

export default {
  props: {
    schema: { type: Object, required: true },
    value: { type: Object, required: true }
  },
  data () {
    return {
      form: {}
    }
  },
  computed: {
    errorMessages () {
      const validations = this.$v.form

      return Object.keys(this.schema).reduce((messages, key) => {
        const rules = this.schema[key].validations
        const rulesKeys = Object.keys(this.schema[key].validations)
        const validator = validations[key]

        if (!validator) return messages

        for (const rule of rulesKeys) {
          if (validator[rule] !== false) continue

          messages[key] = this.$t(rules[rule].message) //rules[rule].message
          return messages
        }

        return messages
      }, {})
    }
  },
  watch: {
    form: {
        handler: function () {
          // console.log("Cambió el form - DF")
          for (const name in this.schema) {
            if (!this.$v.form[name].$model) {
              this.$v.form[name].$model=this.value[name]
            }
          }
        }
    }
  },
  methods: {
    update (key, value) {
      // console.log('Key: ' + key)
      // console.log('Value: '+ value)
      // console.log('Type: '+ this.schema[key].type)
      this.form[key] = value
      this.$v.form[key].$touch()

      this.$emit('input', {
      ...this.value,
      [key]: value
    })
    },
    validate () {
      console.log('Validate del DyanmicForm')
      this.$v.$touch()
      this.announceStatus()
    },
    announceStatus () {
      console.log('AnnounceStatus del DynamicForm')
      this.$emit('status', {
        invalid: this.$v.$invalid
      })
    }
  },
  validations () {
    //Acá está la laucha. Lo del created lo agrego también acá para que cargue el form
    for (const name in this.schema) {
      this.$set(this.form, name, null)
    }
    //Fin acá está la laucha
    return { form: validationRules(this.schema) }
  },
  created () {
    for (const name in this.schema) {
      this.$set(this.form, name, null)
      if (this.$store.state.usr.logueado){
        this.form[name]=this.value[name]
      }
    }
    // this.$v.form.$touch()
  }
}
</script>
